import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import { useCallback, useState } from 'react';
import { OpenModalContainer } from '../openModalContainer';
import { WarningMessageContainer } from '../warningMessageContainer';
/**
 * Utility for testing mobile devices in PWA mode to allow going to a path directly, since there are no browser
 * controls, and the browser may restrict what paths would be honored (if any) when using "Add to Home Screen".
 * This can be used to navigate to a test version of the game at a different path.
 */
export const GoToPathModal = ({ onClose }) => {
    const [path, setPath] = useState('');
    const onChangePath = (event) => {
        setPath(event.target.value);
    };
    const onClickGo = useCallback(() => {
        onClose();
        window.location.href = `/${path}`;
    }, [onClose, path]);
    return (_jsx(OpenModalContainer, { title: 'Go To Path', onClose: onClose, maxWidth: 'md', children: _jsxs(DialogContent, { children: [_jsx(DialogContentText, { component: 'div', children: _jsx(WarningMessageContainer, { message: 'For Testing Purposes' }) }), _jsxs("div", { css: css `
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 5px;
          `, children: [_jsx("div", { children: "/" }), _jsx(TextField, { variant: 'filled', label: 'Path', value: path, onChange: onChangePath, size: 'small', autoCapitalize: 'none', autoComplete: 'off' }), _jsx(Button, { variant: 'contained', color: 'secondary', onClick: onClickGo, children: "Go" })] })] }) }));
};
